import { transparentize } from 'polished'
import { StyleFn } from '..'

export const Backdrop: StyleFn = ({ color }) => ({
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: transparentize(0.4, color.background.backdrop),
    WebkitTapHighlightColor: 'transparent',
  },
})
